module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-footy-lives-here.b1b5bc6a.jpg";